import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT = "Touché | Platonic Connection & Companionship";
const TITLES = {
  "/login": "Sign in · Touche.Today",
  "/register": "Create account · Touche.Today",
  "/practitioners": "Practitioners · Touche.Today",
  "/membership": "Membership · Touche.Today",
  "/resources": "Library · Touche.Today",
  "/community": "Community · Touche.Today",
  "/shop": "Shop · Touche.Today",
  "/dashboard": "Dashboard · Touche.Today",
  "/apply": "Become a Cuddler · Touche.Today",
  "/practitioner": "Practitioner Portal · Touche.Today",
  "/messages": "Messages · Touche.Today",
  "/admin": "Admin · Touche.Today",
  "/about": "About · Touche.Today",
  "/contact": "Contact · Touche.Today",
  "/terms": "Terms of Use · Touche.Today",
  "/privacy": "Privacy Policy · Touche.Today",
};

export const PageTitle = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = TITLES[pathname] || (pathname.startsWith("/practitioners/") ? "Practitioner Profile · Touche.Today" : DEFAULT);
  }, [pathname]);
  return null;
};
